import React from 'react';

const PerksHero = ({ heroConfig }) => (
  <div className="perks-hero" style={heroConfig.bgDesktopImgPath ? { backgroundImage: `url(${heroConfig.bgDesktopImgPath})` } : null} />
);

export default PerksHero;

